import { observer } from "mobx-react-lite";
import { inspectionInfoStorage } from "../../services/ocr/InspectionInfoStorageModel";
import { Typography, Box, Chip, Stack } from "@mui/material";
import React from "react";
import { ArcherContainer, ArcherElement } from "react-archer";
import { translationService } from "../../services/translation/TranslationService";

interface IInspectionInsightDetailsProps {
  inspectionInsightStorage: typeof inspectionInfoStorage;
}

export const InspectionInsightDetails = observer(
  ({ inspectionInsightStorage }: IInspectionInsightDetailsProps) => {
    const {selectedIndex, detections} = inspectionInsightStorage;
    const filteredDetections = selectedIndex !== null
    ? [detections[selectedIndex]]
    : [];

    return (
      <Box sx={{ p: 2 }}>
        <ArcherContainer strokeColor="gray" strokeWidth={1} endMarker>
          {filteredDetections.map((detection, index) => {
            const fields = [
              {label: "Main Code", value: detection.main_Code },
              { label: "C1", value: detection.c1 },
              { label: "C2", value: detection.c2 },
              { label: "Q1", value: detection.q1 },
              { label: "Q2", value: detection.q2 },
              { label: "Position From", value: detection.postionFrom },
              { label: "Position To", value: detection.positionTo },
            ].filter((item) => item.value && item.value.trim() !== "");

            const parentId = `detection-${index}`;

            return (
              <Box
                key={index}
                sx={{
                  border: "1px solid black",
                  borderRadius: 2,
                  p: 3,
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    justifyContent: "center",
                    fontWeight: "bold",
                    color: "#228B22",
                    textDecoration: "underline",
                  }}
                >
                  {translationService.translate("ocrService.inspectionInfo.extractedInsights")}
                </Typography>
                {detection.text && (
                  <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                    <ArcherElement
                      id={parentId}
                      relations={fields.map((_, i) => ({
                        targetId: `${parentId}-child-${i}`,
                        targetAnchor: "top",
                        sourceAnchor: "bottom",
                        style: { strokeDasharray: "0", lineStyle: "straight" },
                      }))}
                    >
                      <Chip
                        label={detection.text}
                        variant="outlined"
                        sx={{
                          mb: 3,
                          maxWidth: "100%",
                          backgroundColor: "#9e9e9e",
                          color: "white",
                          fontWeight: "bold",
                          "& .MuiChip-label": {
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                          },
                        }}
                      />
                    </ArcherElement>
                  </Box>
                )}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Stack direction="row" spacing={1}>
                    {fields.map((item, i) => (
                      <ArcherElement key={i} id={`${parentId}-child-${i}`}>
                        <Chip
                          label={`${item.label}: ${item.value}`}
                          variant="outlined"
                          sx={{
                            backgroundColor: "#228B22",
                            color: "white",
                            "& .MuiChip-label": {
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              overflowWrap: "break-word",
                              display: "block",
                            },
                          }}
                        />
                      </ArcherElement>
                    ))}
                  </Stack>
                </Box>
              </Box>
            );
          })}
        </ArcherContainer>
      </Box>
    );
  }
);
